<template>
  <a-form-item
    class="form-email-field stc-ant-field-skin"
    label="Почта"
    name="email"
    required
  >
    <a-input
      class="form-email-field__input"
      type="email"
      :value="modelValue"
      placeholder="example@mail.ru"
      @update:value="emit('update:modelValue', $event)"
    />
  </a-form-item>
</template>

<script lang="ts" setup>

defineProps<{
  modelValue: string;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();
</script>
